import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-dark-charcoal border-t border-white/10 text-white pt-12 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <GraduationCap className="h-8 w-8 text-vibrant-red" />
              <span className="font-bold text-xl">
                <span className="text-white">Campus</span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-vibrant-red to-dark-red">Qube</span>
              </span>
            </div>
            <p className="text-medium-gray text-sm">
              Empowering university students with opportunities, mentorship, and a VIP community to build their future.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-medium-gray hover:text-white transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-medium-gray hover:text-white transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-medium-gray hover:text-white transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-medium-gray hover:text-white transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-medium-gray hover:text-vibrant-red transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/opportunities" className="text-medium-gray hover:text-vibrant-red transition-colors">Opportunities</Link>
              </li>
              <li>
                <Link to="/vip" className="text-medium-gray hover:text-vibrant-red transition-colors">VIP Membership</Link>
              </li>
              <li>
                <Link to="/contact" className="text-medium-gray hover:text-vibrant-red transition-colors">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-medium-gray hover:text-vibrant-red transition-colors">Student Guidelines</a>
              </li>
              <li>
                <a href="#" className="text-medium-gray hover:text-vibrant-red transition-colors">Mentorship Program</a>
              </li>
              <li>
                <a href="#" className="text-medium-gray hover:text-vibrant-red transition-colors">Success Stories</a>
              </li>
              <li>
                <a href="#" className="text-medium-gray hover:text-vibrant-red transition-colors">Privacy Policy</a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-medium-gray">
                <MapPin className="h-5 w-5 text-vibrant-red flex-shrink-0" />
                <span>Dhaka, Bangladesh</span>
              </li>
              <li className="flex items-start gap-3 text-medium-gray">
                <Mail className="h-5 w-5 text-vibrant-red flex-shrink-0" />
                <span>contact@CampusQube.com</span>
              </li>
              <li className="flex items-start gap-3 text-medium-gray">
                <Phone className="h-5 w-5 text-vibrant-red flex-shrink-0" />
                <span>+880 1234 567890</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/10 mt-12 pt-8 text-center text-medium-gray text-sm">
          <p>&copy; {new Date().getFullYear()} CampusQube. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
